// extracted by mini-css-extract-plugin
export var wrapper = "layout-module--wrapper--F4+5l";
export var scroll_content = "layout-module--scroll_content--n4Zo7";
export var fixed_content = "layout-module--fixed_content--ptGv0";